<script setup>
import {ref} from "vue";
import DeviceAuthCompletePage from "@/components/device/auth/DeviceAuthCompletePage.vue";
import DeviceAuthSuccessPage from "@/components/device/auth/DeviceAuthSuccessPage.vue";

const authCompleted = ref(false);
</script>

<template>
    <div class="flex-fill d-flex justify-center align-start">
        <DeviceAuthCompletePage v-if="!authCompleted" @authComplete="authCompleted = true"/>
        <DeviceAuthSuccessPage v-else/>
    </div>
</template>
